import { ICommand } from 'core-ts-types';
import * as _4 from 'lodash4';
import { PlatformUtility } from 'utility-ts-platform';
import { PathTaskFormatter } from '../../data/functions/path_task_formatter_fn';
import { PathTitleColorService } from '../../data/services/path_color_service';
import { PathModalService } from './../../modals/path_modal_service';

export interface IFlags {
  isCompletable: boolean;
  isDismissible: boolean;
  hasTopic: boolean;
  isOverdue: boolean;
  isDateMarkerEvent: boolean;
  isSyncedToCalendar: boolean;
  isCompleted: boolean;
  isPendingComplete: boolean;
  isAutoCompletable: boolean;
  isDateMarkerTask: boolean;
}

export class PathDetailHeaderController {
  models: any;
  pathTaskDetail: any;
  flags: IFlags;
  format: any;
  topic: any;
  whatIsAutoCompleteModal: any;

  constructor(
    private taskUpdateFn: any,
    private EventCategoryEnum: any,
    private ngPathTaskFormatter: PathTaskFormatter,
    private log: any,
    private $scope: ng.IScope,
    private calendarFacade: any,
    private updateTaskStatusAndModelsCommand: any,
    private pathTitleColorService: PathTitleColorService,
    private ngPathModalService: PathModalService,
    private editReminderCommand: ICommand
  ) {}
  $onInit(): void {
    this.models = {
      taskTopic: !_4.isUndefined(this.topic) ? this.topic : '',
      task: this.pathTaskDetail.source.task,
      taskTopicClass: !_4.isEmpty(this.topic)
        ? this.pathTitleColorService.getTextColorClass(this.topic)
        : this.pathTitleColorService.getTextColorClass(''),
      dateAddedToCalendar: this.pathTaskDetail.source.task.calendar_synced
        ? this.pathTaskDetail.source.task.calendar_synced.format('ddd MMM D').toUpperCase()
        : '',
      subtitle: this.subTitle(this.pathTaskDetail.source.task)
    };
    this.flags = {
      isCompletable: this.models.task.is_completable,
      isDismissible: this.models.task.is_dismissible,
      isPendingComplete: this.isPendingComplete(this.models.task),
      hasTopic: !_4.isEmpty(this.models.topic),
      isOverdue: this.isOverdue(this.models.task),
      isDateMarkerEvent: this.EventCategoryEnum.isDateMarker(this.models.task.category),
      isSyncedToCalendar: !!this.models.task.calendar_synced,
      isCompleted: this.isCompleted(this.models.task),
      isAutoCompletable: this.isAutoCompletable(this.models.task),
      isDateMarkerTask: this.isDateMarkerTask(this.models.task)
    };
    this.format = this.ngPathTaskFormatter;
  }

  $onChanges(): void {
    if (this.models) {
      this.models.subtitle = this.subTitle(this.pathTaskDetail.source.task);
    }
  }

  showCalendarButton(): boolean {
    return this.flags.isDateMarkerEvent && PlatformUtility.isMobile();
  }

  subTitle(task: any): string {
    return this.ngPathTaskFormatter.getPathItemDateText(task, this.isOverdue(task), false);
  }

  isCompleted(task: any): boolean {
    return this.taskUpdateFn.isCompleted(task);
  }

  isOverdue(task: any): boolean {
    return this.taskUpdateFn.isOverdue(task);
  }

  isDismissed(): boolean {
    return this.taskUpdateFn.isDismissed(this.models.task);
  }

  isPersonalReminder(): boolean {
    return this.taskUpdateFn.isPersonalReminder(this.models.task);
  }

  isDismissible(task: any): boolean {
    return task.is_dismissible && !this.taskUpdateFn.isCompleted(task);
  }

  isPendingComplete(task: any): boolean {
    return this.taskUpdateFn.isPendingComplete(task);
  }

  isAutoCompletable(task: any): boolean {
    return this.taskUpdateFn.isAutoCompletable(task);
  }

  isDateMarkerTask(task: any): boolean {
    return this.taskUpdateFn.isDateMarker(task);
  }

  showWhatIsAutoCompleteModal($event: any) {
    $event.stopPropagation();
    this.ngPathModalService.toggleAutoCompleteModal(true);
  }

  toggleDismissed(): void {
    const task = this.models.task;
    const initialStatus = task.status;
    task.status = this.taskUpdateFn.getNewStatusAsString(task, initialStatus, true);
    this.taskUpdateFn.toggleDismissed(task, initialStatus, false).then(
      (updatedTask: any) => {
        this.models.task = updatedTask;
      },
      (err: any) => {
        this.models.task.status = initialStatus;
        this.log.user.error(err);
      }
    );
  }

  addToCalendar(): void {
    this.calendarFacade
      .registerEvent({
        title: this.models.task._title,
        location: undefined,
        notes: undefined,
        startDate: _4.isEmpty(this.models.task.start_ts)
          ? this.models.task.end_ts.toDate()
          : this.models.task.start_ts.toDate(),
        endDate: this.models.task.end_ts.toDate()
      })
      .then((eventIds: string[]) => {
        if (!_.isEmpty(eventIds)) {
          const isAutoComplete = this.isAutoCompletable(this.models.task);
          this.updateTaskStatusAndModelsCommand(this.models.task.status, this.models.task, isAutoComplete, true).then(
            () => {
              this.models.dateAddedToCalendar = 'Just Now';
              this.flags.isSyncedToCalendar = true;
              this.models.task.calendar_synced = moment();
            }
          );
        }
      });
  }

  updateReminderStatus(): void {
    const status = _4.isEqual(this.models.task.status, 'ACTIVE') ? 'COMPLETED' : 'ACTIVE';
    this.editReminderCommand(this.models.task.id, { status });
  }

  updateStatus(): void {
    console.log(this.isDismissed());
    if (this.isDismissed()) {
      this.toggleDismissed();
    } else {
      this.isPersonalReminder() ? this.updateReminderStatus() : this.toggleComplete();
    }
  }

  toggleComplete(): void {
    const task = this.models.task;
    const initialStatus = task.status;

    if (!this.isAutoCompletable(task)) {
      task.status = this.taskUpdateFn.getNewStatusAsString(task, initialStatus, false);
    } else {
      task.is_pending_complete = !task.is_pending_complete;
    }

    this.taskUpdateFn.toggleComplete(task, initialStatus, task.is_pending_complete).then(
      (updatedTask: any) => {
        this.models.task = updatedTask;
        this.flags.isCompleted = this.isCompleted(this.models.task);
        this.flags.isOverdue = this.isOverdue(this.models.task);
        this.flags.isPendingComplete = this.isPendingComplete(this.models.task);
        this.models.subtitle = this.subTitle(updatedTask);
      },
      (err: any) => {
        this.models.task.status = initialStatus;
        this.log.user.error(err);
      }
    );
  }
}

export class PathDetailHeaderComponent implements angular.IComponentOptions {
  public templateUrl: string =
    'capability-ng-todos/src/components/my_path_task_detail_header/my_path_task_detail_header.html';
  public controller: any = PathDetailHeaderController;
  public controllerAs: string = '$ctrl';
  public bindings: any = {
    pathTaskDetail: '<',
    topic: '<'
  };
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-todos/src/components/my_path_task_detail_header/my_path_task_detail_header.ts